// imports section Start
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setGuestRefCode,
  setLoyaltyData,
  setRedeemAmount,
} from "../../../store/ReduxLoyaltySlice";
import DeleteIcon from "@mui/icons-material/Delete";
import { externalgetApi } from "../../../services/external/externalApis";
import { ORDER_API_11 } from "../../../api/ApiModel";
import { CON_STATUS_ACTIVE } from "../../../utils/sys/Constants";
import { styled, useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Button,
  TextField,
  IconButton,
} from "@mui/material";
import { Cached as CachedIcon } from "@mui/icons-material";
// imports section End

const Item = styled(Paper)(({ theme }) => ({
  width: "100%",
  padding: "4px",
}));

function CashierLoyalty() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [searchQuery, setSearchQuery] = useState("");
  const [loyaltyData, setLoyaltyDataState] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [redeemAmount, setRedeemAmountState] = useState(""); // Local state for redeem amount
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch(); // Use Redux dispatch
  const [firstNameFromTable2, setFirstNameFromTable2] = useState("n/a");

  // Retrieve loyalty data and redeem amount from Redux store
  const redeemAmountFromRedux = useSelector(
    (state) => state.loyalty.redeemAmount
  );
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  // Handlers start
  const currentDate = new Date().toISOString().split("T")[0];

  const handleRedeemAmountChange = (e) => {
    const value = e.target.value;
    if (!isNaN(value) && value >= 0) {
      setRedeemAmountState(value);
    }
  };

  // Function to clear the redeem amount
  const handleClearRedeemAmount = () => {
    dispatch(setRedeemAmount("")); // Dispatch an action to clear the redeem amount in Redux
  };
  const handleRedeemNow = () => {
    if (!redeemAmount || redeemAmount <= 0) {
      setErrorMessage("Please enter a valid redeem amount.");
      return;
    }

    const availableAmount = loyaltyData?.Table1?.[0]?.AMOUNT || 0;

    if (parseFloat(redeemAmount) > availableAmount) {
      setErrorMessage(
        `You cannot redeem more than your available amount of ${formatPrice(
          availableAmount
        )}.`
      );
    } else {
      setErrorMessage(""); // Clear any existing errors
      dispatch(setRedeemAmount(redeemAmount)); // Dispatch redeem amount to Redux store
    }
    setRedeemAmountState("");
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      // style: "currency",
      // currency: "USD",
    }).format(price);
  };

  function formatrate(value) {
    if (typeof value === "number") {
      return value
        .toFixed(2) // Ensure two decimal places
        .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Add thousand separators
    }
    return value;
  }

  const formatValue = (value) => {
    if (typeof value === "object" && value !== null) {
      return 0; // Return 0 or some other default value if it's an object
    }
    return value || 0; // Return the value or fallback to 0
  };

  const handleClearSearch = () => {
    setSearchQuery(""); // Clear the local search query state
    setLoyaltyDataState(null); // Clear the local loyalty data state
    dispatch(setLoyaltyData(null)); // Clear the loyalty data in Redux
    setErrorMessage(""); // Clear any error messages
    dispatch(setRedeemAmount(""));
    setFirstNameFromTable2("n/a");
  };

  // Handlers end

  // API calls start
  const handleSearch = async () => {
    setLoading(true);
    setErrorMessage("");
    try {
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        SRCTXT: searchQuery,
        PAYDATE: currentDate, // Set current date for search
        STS: CON_STATUS_ACTIVE, // Add other parameters as needed
      };
      const response = await externalgetApi(ORDER_API_11, "GET", params);
      console.log("loyaltyyyy data", response);
      if (response && response.Table1 && (response.Table1.length > 0|| response.Table2.length > 0)) {
        setLoyaltyDataState(response); // Set full response to local state
        dispatch(setLoyaltyData(response)); // Save parsed response in Redux store
      } else {
        setLoyaltyDataState(null);
        setErrorMessage("No loyalty data found for this customer.");
      }

      if (response && response.Table2 && response.Table2.length > 0) {
        const guestRefCode = response.Table2[0].GUESTREFCODE || null;
        dispatch(setGuestRefCode(guestRefCode));
        const firstName = response.Table2[0].FIRSTNAME;
        setFirstNameFromTable2(firstName || "-"); // Update the state with the first name
      } else {
        console.log("No data available");
      }
    } catch (error) {
      setErrorMessage("Error fetching loyalty data. Please try again.");
    }
    setLoading(false);
  };
  // API calls end

  return (
    <Box sx={styles.cs_cash}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            sx={{ ...theme.typography.h2, color: theme.palette.text.primary }}
          >
            Loyalty Rewards
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Box gap={1} display={"flex"} alignItems={"center"}>
            <TextField
              id="outlined-search"
              placeholder="Mobile no. or loyalty code"
              type="search"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ width: "100%" }}
            />
            <Button
              variant="contained"
              size="large"
              sx={{ ...styles.btn_primary, width: "100px" }}
              onClick={handleSearch}
            >
              Search
            </Button>
            <IconButton
              size="small"
              sx={styles.cs_summary_refresh_icon}
              aria-label="clear search"
              onClick={handleClearSearch}
            >
              <CachedIcon />
            </IconButton>
          </Box>
        </Grid>

        {/* Loyalty Amount */}

        <Grid
          item
          xs={12}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="body2">Name :</Typography>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {firstNameFromTable2}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="body2">Loyalty Amount :</Typography>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {loyaltyData && loyaltyData.Table1 && loyaltyData.Table1[0]
              ? formatrate(formatValue(loyaltyData.Table1[0].AMOUNT))
              : 0}
          </Typography>
        </Grid>

        {/* Loyalty Points */}
        <Grid
          item
          xs={12}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="body2">Loyalty Points :</Typography>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {loyaltyData && loyaltyData.Table1 && loyaltyData.Table1[0]
              ? formatPrice(formatValue(loyaltyData.Table1[0].POINTS))
              : 0}
          </Typography>
        </Grid>

        {/* Redeem Amount Input */}
        <Grid item xs={12}>
          <TextField
            id="outlined-basic"
            label="Redeem Amount"
            variant="outlined"
            size="small"
            fullWidth
            value={redeemAmount}
            onChange={handleRedeemAmountChange}
            error={!!errorMessage}
            helperText={errorMessage}
          />
        </Grid>

        {/* Redeem Now Button */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            size="medium"
            sx={styles.btn_primary}
            fullWidth
            onClick={handleRedeemNow}
          >
            Redeem Now
          </Button>
        </Grid>

        {/* Display Redeem Amount from Redux */}
        <Grid item xs={12}>
          <Item sx={{ marginTop: "20px" }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={10}>
                <Typography variant="body2">Redeem Amount:</Typography>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  {redeemAmountFromRedux
                    ? formatPrice(redeemAmountFromRedux)
                    : "N/A"}
                </Typography>
              </Grid>

              {/* Delete Icon to clear redeem amount */}
              <Grid
                item
                xs={2}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <IconButton onClick={handleClearRedeemAmount} color="error">
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Item>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CashierLoyalty;
